import Vue from 'vue'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd);


import App from './App.vue'
import router from './router'
import store from './store/index'

//App Styling
import './assets/scss/app.scss'


import InfiniteScroll from 'v-infinite-scroll'
Vue.use(InfiniteScroll)

import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
Vue.use(VueVirtualScroller)

import VueBarcodeScanner from 'vue-barcode-scanner'
Vue.use(VueBarcodeScanner)


import Lodash from 'lodash'
Object.defineProperty(Vue.prototype, '$lodash', { value: Lodash })

import hub from './services/communication/hub.js'

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.config.productionTip = false

new Vue({
  router,
  store,
  hub,
  provide() {
    return {
      eventBus: new Vue(),
      hub
    }
  },
  render: h => h(App)
}).$mount('#app')
